import { useAuth } from '../contexts/AuthContext';
import { rbacService, ADMIN_EMAIL } from '../services/rbacService';

export { ADMIN_EMAIL };

/**
 * Single source of truth for admin check.
 * Returns true if the user email matches the master ADMIN_EMAIL
 * OR if the user has been assigned the 'admin' role via RBAC.
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  if (!user || !user.email) return false;
  if (user.email === ADMIN_EMAIL) return true;
  return rbacService.getRole(user.email) === 'admin';
}
